import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api, formatErr } from "@/lib/api";

const SPORTS = ["Multi-Sport", "Badminton", "Basketball", "Football", "Futsal", "Padel", "Pickleball", "Squash", "Tennis", "Volleyball", "Other"];
const FIELDS = [["business_name", "Business name"], ["owner_name", "Owner name"], ["email", "Email", "email"], ["phone", "Phone"], ["address", "Venue address"], ["site_url", "Your website (if you have one)"]];

export default function VendorRegister() {
  const [f, setF] = useState({ business_name: "", owner_name: "", email: "", phone: "", sport: "Multi-Sport", address: "", site_url: "", note: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/platform/register", f); setDone(true); } catch (err) { toast.error(formatErr(err)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[#060A12] px-5 py-12 text-white" data-testid="vendor-register-page">
      <div className="mx-auto max-w-2xl">
        <Link to="/" className="text-sm text-slate-400 hover:text-white">← All Sports Venues</Link>
        <h1 className="mt-4 font-display text-4xl font-black uppercase sm:text-5xl">List your venue</h1>
        <p className="mt-2 text-sm text-slate-400">Tell us about your venue. We'll set up your own booking site and connect it to All Sports Venues.</p>
        {done ? (
          <div className="mt-8 flex items-start gap-3 rounded-2xl border border-emerald-500/40 bg-emerald-950/30 p-6" data-testid="vendor-register-done">
            <CheckCircle2 className="mt-0.5 h-5 w-5 text-emerald-400" /><div><p className="font-semibold">Thanks, we've got your details.</p><p className="mt-1 text-sm text-slate-300">Our team will contact you at {f.email} to get your venue online.</p></div>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 grid gap-4 rounded-2xl border border-slate-800 p-6 sm:grid-cols-2">
            {FIELDS.map(([k, l, t]) => <div key={k} className="space-y-1.5"><Label>{l}</Label><Input type={t || "text"} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} required={!["address", "site_url"].includes(k)} placeholder={k === "site_url" ? "https://" : ""} data-testid={`reg-${k}-input`} /></div>)}
            <div className="space-y-1.5"><Label>Sport</Label>
              <select value={f.sport} onChange={(e) => setF({ ...f, sport: e.target.value })} className="h-10 w-full rounded-md border border-slate-700 bg-slate-950 px-3 text-sm" data-testid="reg-sport-select">{SPORTS.map((s) => <option key={s}>{s}</option>)}</select>
            </div>
            <div className="space-y-1.5 sm:col-span-2"><Label>Anything else?</Label><Textarea rows={3} value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} placeholder="Number of courts, opening hours, questions…" data-testid="reg-note-input" /></div>
            <Button type="submit" disabled={busy} className="rounded-full sm:col-span-2" data-testid="reg-submit-button">{busy ? "Sending..." : "Send my details"}</Button>
          </form>
        )}
      </div>
    </div>
  );
}
